import { render, staticRenderFns } from "./default.vue?vue&type=template&id=00505a62&scoped=true"
import script from "./default.vue?vue&type=script&setup=true&lang=ts"
export * from "./default.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./default.vue?vue&type=style&index=0&id=00505a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00505a62",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxNav: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Nav.vue').default,IxCardWorkspaceMoved: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/card/WorkspaceMoved.vue').default})
